module.exports = __webpack_public_path__ + "static/media/succeed1.d71771e6.jpg";